import React from "react";
import "@styles/SingleHotelViewcss/Dashboard.css";
import GeneralInformation from "./GeneralInformation";
import TotalOrders from "./TotalOrders/TotalOrders";
import TotalTransactions from "./TotalTransactions";
import PerformanceMetrics from "./PerformanceMetrics";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { useLocation, useParams } from "react-router-dom";

const DemoPaper = styled(Paper)(({ theme }) => ({
  
  padding: theme.spacing(2),
  ...theme.typography.body2,
  
}));



const tabStyle = {
  fontStyle: "normal",
  letterSpacing: "0px",
  textTransform: "capitalize",
  fontSize: "14px",
  margin: "0px",
  padding: "0px",
  marginRight: "10px",
  fontWeight: '600',
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Dashboard() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const location = useLocation();
  const { name, status, foodCourtId } = location.state || { name: 'Unknown', status: 'Unknown', foodCourtId: 'N/A' };

  console.log("Hotel Name:", name);
  console.log("Hotel Status:", status);
  console.log("Food Court ID:", foodCourtId);
  return (
    <div className="DashboardContainer">
      <DemoPaper square>
      <Box  sx={{ width: "100%" }}>
        <Box
          sx={{ borderBottom: 1, borderColor: "divider" }}
          className="DashboardHeader"
        >
          <h1 className="DashboardTitle">{name? name :"FoodCourt"}</h1>
          <div className="chip">
            <p className="textactive">{status? status:"Closed"}</p>
          </div>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
            <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{ display: "flex", gap: "10px" }}
        >
          <Tab sx={tabStyle} label="General Information" {...a11yProps(0)} />
          <Tab sx={tabStyle} label="Total Orders" {...a11yProps(1)} />
          <Tab sx={tabStyle} label="Performance Metrics" {...a11yProps(2)} />
        </Tabs>
            </div>
            <div>
              <div style={{ display: "flex", gap: "15px" }}>
                <div>
                  <div className="search-box2">
                    <button>
                      <i className="bx bx-search" />
                    </button>
                    <input type="text" placeholder="Search..." />
                  </div>
                </div>
                <div>
                  {" "}
                  <div className="dropdown">
                    <select
                      className="dropdown2-btn"
                     
                      // value={selectedDateType}
                      // onChange={handleDateTypeChange}
                    >
                      <option value="">Date types</option>
                      <option value="Year">Year</option>
                      <option value="Month">Month</option>
                      <option value="Today">Today</option>
                    </select>
                  </div>
                </div>
                <div>
                  <div className="dropdown">
                    <button className="dropdown2-btn">
                      <i
                        className="bx bx-filter"
                        style={{ marginRight: "4px" }}
                      />
                      Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* className="searchdiv" */}
        </Box>

        <CustomTabPanel  value={value} index={0}>
          <GeneralInformation />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <TotalOrders id={foodCourtId}/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <PerformanceMetrics id={foodCourtId}/>
        </CustomTabPanel>
      </Box>
      </DemoPaper>
    </div>
  );
}
